export default __webpack_public_path__ + "static/media/VFC_Jahresbericht_2015.529c56cc.pdf";